// extracted by mini-css-extract-plugin
export var closeButton = "Modal-module--closeButton--4e0c2";
export var condensed = "Modal-module--condensed--342cb";
export var content = "Modal-module--content--787cb";
export var expanded = "Modal-module--expanded--d6dc9";
export var icon = "Modal-module--icon--6d2b4";
export var mobileFullScreen = "Modal-module--mobileFullScreen--12e62";
export var modal = "Modal-module--modal--86ea5";
export var overlay = "Modal-module--overlay--1e934";